<mat-nav-list>
  <!-- 4AI ASSISTANT: Item estatico antes de Favorites.
       Gated by ai.use so a role without AI access sees no launcher here either — it appears/hides
       together with the floating <app-ai-panel> (same permission), never one without the other. -->
  <div *hasPermission="'ai.use'" class="ai-assistant-item" (click)="toggleAiPanel()" title="4AI Assistant">
    <div class="ai-assistant-icon-wrapper">
      <i class="fa-solid fa-wand-magic-sparkles ai-assistant-icon"></i>
    </div>
    <span class="ai-assistant-label">4AI Assistant</span>
    <span class="ai-assistant-badge">Beta</span>
  </div>

  <!-- FAVORITES: Secci�n est�tica -->
  <ng-container *ngIf="categories && categories.length > 0">
    <ng-container *ngFor="let category of categories; let i = index">
      <ng-container *ngIf="category.name === 'Favorites'">
        <div class="category-header"
             (click)="toggleCategory(i)"
             [ngClass]="{'collapsed': !category.isExpanded, 'expanded': category.isExpanded}">
          <i *ngIf="category.iconClass" class="category-icon" [ngClass]="category.iconClass"></i>
          <span class="category-name">{{ category.name }}</span>
          <span class="custom-caret" [ngClass]="{'rotate': category.isExpanded}"></span>
        </div>
        <div [@menuToggle]="category.isExpanded ? 'expanded' : 'collapsed'">
          <div class="direct-menu-items favorites-menu-items">
            <!-- My Dashboard SIEMPRE primero, est�tico -->
            <div class="favorites-item-wrapper">
              <app-sidenav-item
                [item]="{ displayName: 'SIDEMENU.MY_DASHBOARD', iconClass: 'fas fa-chart-pie', route: 'master-dashboard' }"
                [isInFavorites]="true"
                class="favorites-item">
              </app-sidenav-item>
            </div>
            <!-- Luego los favoritos din�micos, ya filtrados en TS -->
            <div class="favorites-item-wrapper" *ngFor="let option of favoriteMenuItems">
              <app-sidenav-item
                [item]="option"
                [isInFavorites]="true"
                class="favorites-item">
              </app-sidenav-item>
              <!-- Icono eliminar o spinner si est� eliminando -->
              <span class="remove-favorite-icon"
                    title="{{'SIDEMENU.REMOVE_FROM_FAVORITES' | translate}}"
                    (click)="removeFavorite(option, $event)">
                <i *ngIf="!removingFavorites.has(option.route)" class="fas fa-minus-circle"></i>
                <i *ngIf="removingFavorites.has(option.route)" class="fas fa-spinner fa-spin"></i>
              </span>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </ng-container>

  <!-- MENÚ DINÁMICO POR SUSCRIPCIÓN (Incluye 4Bridge, 4Comply, 4Preferences, etc.) -->
  <ng-container *ngIf="modules && modules.length > 0">
    <ng-container *ngFor="let module of modules; let mi = index">
      <!-- MÓDULO HABILITADO: renderizado normal (subscrito Y con permiso de lectura del módulo) -->
      <ng-container *ngIf="module.isEnabled && isModulePermitted(module)">
        <div class="category-header"
             (click)="onModuleHeaderClick(module)"
             [ngClass]="{'collapsed': !module.isExpanded, 'expanded': module.isExpanded}">
          <img *ngIf="logoFor(module)" class="category-image" [alt]="module.name"
               [src]="logoFor(module)" [style.height]="module.height || '22px'" />
          <!-- A module that navigates has no children: no caret, no collapsible block -->
          <span class="custom-caret" *ngIf="!moduleNavigates(module)" [ngClass]="{'rotate': module.isExpanded}"></span>
        </div>
        <div *ngIf="!moduleNavigates(module)" [@menuToggle]="module.isExpanded ? 'expanded' : 'collapsed'">
          <ng-container *ngFor="let category of getVisibleCategories(module)">
            <mat-accordion *ngIf="category.name && category.name.trim() !== ''">
              <mat-expansion-panel [expanded]="category.expandedByDefault">
                <mat-expansion-panel-header collapsedHeight="35px" expandedHeight="35px" multi>
                  <mat-panel-title>
                    <h1 class="expansion-title">{{ category.name | translate }}</h1>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <app-sidenav-item *ngFor="let item of getVisibleItems(category)"
                                  [item]="{ displayName: item.label, iconClass: item.icon, route: item.route, isLocked: item.hasAccess === false }"
                                  [isInFavorites]="false">
                </app-sidenav-item>
              </mat-expansion-panel>
            </mat-accordion>
            <!-- Si la categoría no tiene nombre, mostrar items directamente -->
            <ng-container *ngIf="!category.name || category.name.trim() === ''">
              <div class="direct-menu-items">
                <app-sidenav-item *ngFor="let item of getVisibleItems(category)"
                                  [item]="{ displayName: item.label, iconClass: item.icon, route: item.route, isLocked: item.hasAccess === false }"
                                  [isInFavorites]="false">
                </app-sidenav-item>
              </div>
            </ng-container>
          </ng-container>
        </div>
      </ng-container>

      <!-- MÓDULO NO SUSCRITO: header bloqueado, sin expandir -->
      <ng-container *ngIf="!module.isEnabled">
        <div class="category-header locked-module"
             (click)="onLockedModuleClick(module)"
             [attr.title]="'SIDEMENU.UPGRADE_REQUIRED' | translate">
          <img *ngIf="logoFor(module)" class="category-image" [alt]="module.name"
               [src]="logoFor(module)" [style.height]="module.height || '22px'" />
          <span class="lock-indicator">
            <i class="fa-solid fa-lock lock-icon"></i>
            <span class="tier-badge">{{ 'SIDEMENU.UPGRADE' | translate }}</span>
          </span>
        </div>
      </ng-container>
    </ng-container>
  </ng-container>
</mat-nav-list>
